// extracted by mini-css-extract-plugin
export default {"faqContent":"Faq_faqContent__Z+6ak"};